@if (tooltip) {
  <div
    #tooltipContainer
    class="tooltip"
    [class.tooltip--visible]="visible"
    [ngClass]="position"
  >
    {{ tooltip }}
    <div class="tooltip-arrow"></div>
  </div>
}
